import { render, staticRenderFns } from "./comp_BookEditorInput-TextField.vue?vue&type=template&id=b5a48598&scoped=true&"
import script from "./comp_BookEditorInput-TextField.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorInput-TextField.vue?vue&type=script&lang=js&"
import style0 from "./comp_BookEditorInput-TextField.vue?vue&type=style&index=0&id=b5a48598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a48598",
  null
  
)

export default component.exports